'use client';

import { Badge } from '@/components/ui/badge';
import { Label } from '@/components/ui/label';
import React from 'react';

interface FilterSectionProps {
  title: string;
  children: React.ReactNode;
  required?: boolean;
  description?: string;
}

export function FilterSection({
  title,
  children,
  required = false,
  description,
}: FilterSectionProps) {
  return (
    <div className='space-y-1'>
      <div className='flex items-center justify-between'>
        <div className='flex items-center'>
          <Label className='text-sm font-medium text-foreground'>{title}</Label>
          {required && (
            <Badge variant='secondary' className='text-xs h-5 px-1.5'>
              필수
            </Badge>
          )}
        </div>
      </div>
      {description && (
        <p className='text-xs text-muted-foreground'>{description}</p>
      )}
      <div className='space-y-2'>{children}</div>
    </div>
  );
}
